<div class="features" fxLayout="row" fxLayout.lt-md="column">
    <div fxFlex fxLayout="column" fxLayoutGap.xs="28px">
        <div fxLayout="row" fxLayoutGap="20px" fxFlexAlign="end">
            <button class="btn btn-outline-danger" (click)="onDeny()">Deny</button>
            <button class="btn btn-outline-danger" (click)="onGoogleTime()">Google Time</button>
            <button class="btn btn-outline-danger" (click)="onManualTime()">Manual time</button>
        </div>
    </div>
</div>